import { render, staticRenderFns } from "./orderStatementsPage.vue?vue&type=template&id=0761de7e&"
import script from "./orderStatementsPage.vue?vue&type=script&lang=ts&"
export * from "./orderStatementsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports